import { SkeletonCircle as ChakraSkeletonCircle } from '@chakra-ui/react';
import React from 'react';

import { SkeletonProps, defaultProps, propTypes } from './Skeleton';
import DisplayNames from './enums';

const SkeletonCircle = (props: SkeletonProps & typeof defaultProps): React.ReactElement => {
  const { isAnimated, speed, ...rest } = props;
  return <ChakraSkeletonCircle speed={isAnimated ? speed : 0} {...rest} />;
};

SkeletonCircle.defaultProps = defaultProps;
SkeletonCircle.displayName = DisplayNames.SkeletonCircle;
SkeletonCircle.propTypes = propTypes;

export default SkeletonCircle;
